import React from 'react';
import PropTypes from 'prop-types';
import RecentsMigrationModal from '../../components/RecentsMigrationModal/RecentsMigrationModal';
import NavigationModal from '../../components/Navigation/NavigationModal/NavigationModal';
import { useChangeCashierResultURL } from '../../hooks/useChangeCashierResultURL';
import { useIsDesktopLayout } from '../../hooks/useMediaQuery';
import { useNativeHeader } from '../../hooks/useNativeHeader';
import { useViewConfig } from '../../hooks/useViewConfig';
import { useClickStreamPageView } from '../../hooks/useClickStreamPageView';
import { SEO_WRAPPER_COLLECTION } from '../../constants/viewConfig';
import styles from './SingleLayout.module.css';

export const SingleLayout = ({ children }) => {
  useChangeCashierResultURL();
  useNativeHeader();
  useClickStreamPageView();
  const isDesktop = useIsDesktopLayout();
  const SEOWrapper = useViewConfig(SEO_WRAPPER_COLLECTION);

  return (
    <section className={styles['lc-container']}>
      {children}
      <SEOWrapper />
      {!isDesktop && <NavigationModal />}
      <RecentsMigrationModal />
    </section>
  );
};

SingleLayout.propTypes = {
  children: PropTypes.element,
};

SingleLayout.defaultProps = {
  children: null,
};

export default SingleLayout;
